import React, { useEffect } from 'react';
import { Radio } from '@ftdr/blueprint-components-react';
import {
  ACTION_ADD_AS_COOPERATING_AGENT,
  ACTION_CONTACT_SUPPORT,
} from '@constants/newOrder-constants';
import { ContractDetail } from '@apis/models';
import { propertyObjectToString } from '@services/helpers';
import { useNavigate } from 'react-router-dom';
import Path from '@constants/paths';
import REText from '@components/wrappedBDS/REText';

interface Props {
  setRadio: (string) => void;
  selectedRadio: string;
  contract: ContractDetail;
}

const AssociateAgent: React.FC<Props> = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!props.contract) {
      navigate(Path.Dashboard);
      return;
    }
  }, [props.contract]);

  const getLabel = () => {
    let type = '';

    if (props.contract?.initiatingOfficeAgent?.represents === 'SELLER') {
      type = 'Buyer';
    } else {
      type = 'Seller';
    }

    return `Add me as the ${type} Agent on this order`;
  };

  return (
    <>
      <REText variant="heading-06">Order ID: {props.contract.id}</REText>
      <REText variant="heading-06">Address: {propertyObjectToString(props.contract.property)}</REText>
      <div className="w-full px-4 py-2">
        <div>
          <Radio
            label={getLabel()}
            name="cooperatingAgent"
            id="radio-Add-me"
            value={ACTION_ADD_AS_COOPERATING_AGENT}
            checked={props.selectedRadio === ACTION_ADD_AS_COOPERATING_AGENT}
            onChange={(e) => props.setRadio(e.target.value)}
            labelPlacement="right"
            width="auto"
            color="interactive"
          />
        </div>
        <div>
          <Radio
            label="Contact Support"
            name="contact-support"
            id="radio-contact-suppoer"
            value={ACTION_CONTACT_SUPPORT}
            checked={props.selectedRadio === ACTION_CONTACT_SUPPORT}
            onChange={(e) => props.setRadio(e.target.value)}
            labelPlacement="right"
            width="auto"
            color="interactive"
          />
        </div>
      </div>
    </>
  );
};

export default AssociateAgent;
